import CommonAppointmentCalendar from "./CommonAppointmentCalendar";
import PropTypes from "prop-types";

export const ReceptionistAppointmentCalendar = ({
  patientId,
  doctorId,
  leadId,
  initialAppointmentId,
  currentAppointmentData,
  onRescheduleSuccess,
  onRescheduleError,
  onRescheduleStart,
  onRescheduleEnd,
  isNewBooking = false,
  onHide,

}) => {
  return (
    <CommonAppointmentCalendar
      patientId={patientId}
      doctorId={doctorId}
      leadId={leadId}
      module="receptionist"
      appointmentType="receptionist"
      initialAppointmentId={initialAppointmentId}
      allowBooking={isNewBooking} // Allow booking for new appointments
      currentPatientId={patientId}
      onRescheduleSuccess={onRescheduleSuccess}
      onRescheduleError={onRescheduleError}
      onRescheduleStart={onRescheduleStart}
      onRescheduleEnd={onRescheduleEnd}
      isNewBooking={isNewBooking}
      currentAppointmentData={currentAppointmentData}
      onHide={onHide}
    />
  );
};

ReceptionistAppointmentCalendar.propTypes = {
  patientId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  doctorId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  leadId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  initialAppointmentId: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  currentAppointmentData: PropTypes.object,
  onRescheduleSuccess: PropTypes.func,
  onRescheduleError: PropTypes.func,
  onRescheduleStart: PropTypes.func,
  onRescheduleEnd: PropTypes.func,
  isNewBooking: PropTypes.bool,
};

export default ReceptionistAppointmentCalendar;
